import { render, staticRenderFns } from "./EditNewsfeed.vue?vue&type=template&id=c3e30f50&"
import script from "./EditNewsfeed.vue?vue&type=script&lang=js&"
export * from "./EditNewsfeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports